import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = 'teamMeetingConfig';

export interface ITeamMeetingConfigsQueryParams {
	pageSize?: number;
	pageToken?: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

export function useTeamMeetingConfigsQuery(params: ITeamMeetingConfigsQueryParams = {}) {
	const { pageSize = 25, pageToken, enabled = true, impersonationContext } = params;
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			const queryParams: Record<string, string> = {};
			if (pageSize) queryParams.pageSize = String(pageSize);
			if (pageToken) queryParams.pageToken = pageToken;

			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ITeamMeetingConfig>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams,
					urlPath: 'TeamMeetingConfig',
				}),
				'GET'
			);
		},
		queryKey: [BASE_API_KEY, 'list', impersonationContext, pageSize, pageToken],
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load team meeting links',
		},
	});
}

export const invalidateTeamMeetingConfigsQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};
